<template>
  <div :class="$style.authNPoliciesGuidedSetup">
    <Card :class="$style.guidedSetupCard">
      <template v-slot:header>
        <div
          :class="$style.cardHeader"
        >
          <div :class="$style.titleContainer">
            <HeadingLarge>
              Zero Trust Policies
            </HeadingLarge>
            <StatusBadge
              :class="$style.badge"
              icon="premiumDiscover"
              :status="badgeStatus"
              text="Explore Zero Trust"
            />
          </div>
          <Button
            :class="$style.toggleBtn"
            :hasNoBackground="true"
            :outline="false"
            :text="collapsed ? 'expand' : 'collapse'"
            @click="toggleExpanded"
          />
        </div>
      </template>
      <template v-slot:body>
        <TransitionWrapper
          :class="$style.collapsibleSection"
          :isExpanded="!collapsed"
          name="slideVertical"
          title=""
        >
          <ParagraphBody
            v-if="!collapsed"
            :class="$style.cardsContainer"
          >
            <AuthNSimulationCard
              v-for="card in cardList"
              :key="card.title"
              :class="$style.authNCard"
              :content="card.text"
              :guideName="card.guideName"
              :iframeSrc="card.iframeSrc"
              :simulationUrl="card.simulationUrl"
              :title="card.title"
            />
          </ParagraphBody>
        </TransitionWrapper>
      </template>
    </Card>
  </div>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import {
  capZeroStateViewCards,
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import FeatureTrialMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';

import {
  Button,
  Card,
  HeadingLarge,
  ParagraphBody,
  StatusBadge,
  TransitionWrapper,
} from '@jumpcloud/ui-components';
import AuthNSimulationCard from 'client/Security/AuthNPoliciesGuidedSetup/AuthNSimulationCard.vue';

export default {
  name: 'AuthNPoliciesGuidedSetup',

  components: {
    AuthNSimulationCard,
    Button,
    Card,
    HeadingLarge,
    ParagraphBody,
    StatusBadge,
    TransitionWrapper,
  },

  EventHelper,

  mixins: [FeatureTrialMixin],

  data: () => ({
    collapsed: localStorage.getItem(LocalStorageConsts.authNPoliciesZeroStateGuidedSetupCollapsed) === 'true',
  }),

  computed: {
    badgeStatus() {
      return this.getIsCustomer && !this.planHasFeature('zeroTrust')
        ? 'premium'
        : 'informational';
    },

    cardList() {
      return capZeroStateViewCards;
    },
  },

  methods: {
    toggleExpanded() {
      const expansionText = this.collapsed ? 'Expanded' : 'Collapsed';
      this.collapsed = !this.collapsed;
      localStorage
        .setItem(LocalStorageConsts.authNPoliciesZeroStateGuidedSetupCollapsed, this.collapsed);

      this.$options.EventHelper.triggerButtonClicked({
        [eventProperties.location]: eventLocations.conditionalPoliciesPage,
        [eventProperties.description]: `Auth N Policies Guided Setup Cards Container ${expansionText}`,
        [eventProperties.section]: 'Auth N Policies Guided Setup Cards Container',
      });
    },
  },
};
</script>

<style scoped module>
.authNCard {
  flex: 1;
  margin: var(--jc-spacer-small);
}

.authNPoliciesGuidedSetup {
  margin-bottom: var(--jc-spacer-medium);
  max-width: 100%;
  padding-top: 0;
}

.authNPoliciesGuidedSetup .titleContainer {
  align-items: center;
  display: flex;
  flex: 1;
}

.authNPoliciesGuidedSetup .titleContainer h2 {
  margin-bottom: 0;
}

.badge {
  margin-left: var(--jc-spacer-small);
  margin-top: var(--jc-spacer-x-small);
  text-transform: initial;
}

.cardHeader {
  display: flex;
}

.cardList {
  display: flex;
}

.cardsContainer {
  display: flex;
  flex-wrap: wrap;
}

.collapsibleSection {
  padding-top: var(--jc-spacer-medium);
}

/** Override extra padding on card header. */
.guidedSetupCard /deep/ header {
  padding-bottom: 0;
}

.toggleBtn span {
  color: var(--jcGrey900);
}

@media screen and (max-width: 740px) {
  .authNPoliciesGuidedSetup > .guidedSetupCard {
    padding: var(--jc-spacer-x-small);
  }

  .title {
    flex-direction: column;
  }
}
</style>
